@if (isLoading) {
  <div class="overlay">
    <mat-progress-spinner class="spinner" [color]="color" [mode]="mode"  />
  </div>
}
